// action types
export const SET_PAGINATION = 'common/SET_PAGINATION'

// reducers
const initialState = {
  totalPage: 1,
  pageMod: 0
}

export const pagination = (state = initialState, action) => {
  switch (action.type) {
    case SET_PAGINATION:
      return {
        ...state,
        totalPage: action.totalPage,
        pageMod: action.pageMod,
      }
    default:
      return state
  }
}

export default pagination
